import { useCallback, useEffect, useState } from 'react';
import { Document } from './types';

const useGeneratedDocument = (generate: (declarationId: string) => Promise<Document>) => {
    const [file, setFile] = useState<Document | undefined>();
    const [url, setUrl] = useState<string | undefined>();
    const [loading, setLoading] = useState<boolean>(false);

    const fetchDocument = useCallback(
        async (declarationId: string) => {
            setLoading(true);

            try {
                setFile(await generate(declarationId));
            } catch {
                setFile(undefined);
            } finally {
                setLoading(false);
            }
        },
        [generate]
    );

    useEffect(() => {
        if (!file) return setUrl(undefined);

        const objectUrl = URL.createObjectURL(file.blob);
        setUrl(objectUrl);

        // Every regeneration mints a new object URL, so release the one it replaces.
        return () => URL.revokeObjectURL(objectUrl);
    }, [file]);

    return { file, url, loading, fetchDocument };
};

export default useGeneratedDocument;
